import { Route } from '@angular/router';
import { RouteGuard } from '../auth/route.guard';

const reportsRoutes: Route[] = [
  {
    path: 'reports',
    canActivate: [RouteGuard],
    loadChildren: () =>
      import('./reports/reports.module').then((m) => m.ReportsModule),
  },
];

export default reportsRoutes;
